import { render, staticRenderFns } from "./ResultGenou.vue?vue&type=template&id=4b7d574c&scoped=true&"
import script from "./ResultGenou.vue?vue&type=script&lang=js&"
export * from "./ResultGenou.vue?vue&type=script&lang=js&"
import style0 from "./ResultGenou.vue?vue&type=style&index=0&id=4b7d574c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7d574c",
  null
  
)

export default component.exports